import { Customer } from '@models';

export interface CustomerState {
  customers: Customer[];
  fetchedAt: Date | null;
}

export const initialCustomerState: CustomerState = {
  customers: [],
  fetchedAt: null,
};
